import React from 'react'
import { GiftCardTileProps } from './GiftCardTile'

export const GiftCardBadge = (props: GiftCardTileProps) => {
  const { amount, giftCardPreviewUrl } = props

  const backgroundStyle = {
    borderRadius: '8px',
    height: '44px',
    aspectRatio: '1.6',
    backgroundImage: `url(${giftCardPreviewUrl})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    position: 'relative' as const,
    AspectRatio: '1/1',
  }

  const badgeStyles = {
    padding: '4px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '34px',
    backgroundColor: '#ffffffad',
    backdropFilter: 'blur(27px)',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.08)',
    color: '#444',
    fontFamily: 'Monserrat, sans-serif',
    fontWeight: 700,
    fontSize: '10px',
    position: 'absolute',
    top: '-7px',
    left: '-5px',
  } as const
  return (
    <div style={{ ...backgroundStyle }}>
      <div style={{ ...badgeStyles }}>${amount.split('.')[0]}</div>
    </div>
  )
}
